export default function CloseIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.30659 11.3359L6.63773 8.00475L3.33145 4.69848L4.72357 3.30636L8.02984 6.61264L11.3361 3.30636L12.7448 4.71505L9.43853 8.02133L12.7448 11.3276L11.3527 12.7197L8.04642 9.41344L4.71528 12.7446L3.30659 11.3359Z"
        fill="#207E7D"
      />
    </svg>
  );
}
